import Index from '@/pages/matterManage';
import matterCreated from "@/pages/matterManage/matterCreated"
export default [
    {
        path:'/matterManage',
        component:Index,
        meta: {
            keepAlive: true
        }
    },{
        path:'/matterManage/matter_created',
        component:matterCreated
    }
]